export default {
  title: 'Facturas',
  form: {
    auto_generate_invoices: {
      label: 'Generar facturas automáticamente',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    failed_to_save_changes: 'Error al guardar los cambios',
    changes_got_saved: 'Cambios guardados',
  },
};
